import React from "react";

import "./style.sass";

import gradingSystemImg from "../../../pic/grading-system.png";
import GradingSystemItem, {IGradingSystemItem} from "../grading-system-item";

const listitems: IGradingSystemItem[] = [
    {
        id: 1,
        name: "Информация об ученике",
        coordinates: {
            desktop: {
                top: '8%',
                left: '0',
                right: '0',
            },
            mobile: {
                top: '8%',
                left: '0',
                right: '0',
            },
        }

    },
    {
        id: 2,
        name: "Общий прогресс",
        info: "Диаграмма показывает, сколько компетенций осталось до следующего уровня",
        coordinates: {
            desktop: {
                top: '15%',
                left: '0',
                right: '0',
            },
            mobile: {
                top: '15%',
                left: '0',
                right: '0',
            }
        }

    },
    {
        id: 3,
        name: "Прогресс по отдельным компетенциям",
        coordinates: {
            desktop: {
                top: '48%',
                left: '0',
                right: '0%',
            },
            mobile: {
                top: '48%',
                left: '0',
                right: '0%',
            }

        }
    },
    {
        id: 4,
        name: "Информация о наставнике",
        coordinates: {
            desktop: {
                top: '8%',
                left: '75%',
                right: '0',
            },
            mobile: {
                top: '8%',
                left: '80%',
                right: '0',
            }

        }
    },
    {
        id: 5,
        name: "Канбан доска с компетенциями",
        coordinates: {
            desktop:
                {
                    top: '70%',
                    left: '75%',
                    right: '0',
                },
            mobile: {
                top: '70%',
                left: '80%',
                right: '0',
            }
        }
    },
    {
        id: 6,
        name: "Шкала прогресса",
        coordinates: {
            desktop: {
                top: '92%',
                left: '75%',
                right: '0',
            },
            mobile: {
                top: '92%',
                left: '80%',
                right: '0',
            }

        }
    },
];

const GradingSystem = () => {
    return (
        <div className="grading-system">
            <div className='grading-system__img-wrapper'>
                <img
                    className="grading-system__img"
                    src={gradingSystemImg}
                    alt="grading-system"
                />
                {listitems.map((item, index) => {
                    return <GradingSystemItem {...item} key={index}/>;
                })}
            </div>

        </div>
    );
};

export default GradingSystem;
